module.exports = __webpack_public_path__ + "img/ins.33241c9d.jpg";